import { DateFormat, formatUtils } from '@kanbu/shared';
import { useLingui } from '@lingui/react/macro';
import { CalendarClock, CalendarPlus } from 'lucide-react';
import { memo } from 'react';

import { Card } from '../card/Card';
import { DisplayValue } from '../displayValue/DisplayValue';

export type MetaFieldsProps = {
  children?: React.ReactNode;
  data:
    | {
        createdAt?: string;
        updatedAt?: string;
      }
    | undefined;
};

/**
 * Card component used in third column of form, to display meta fields.
 */
export const MetaFields = memo(function MetaFields({
  data,
  children,
}: MetaFieldsProps) {
  const { t } = useLingui();
  const { createdAt, updatedAt } = data ?? {};

  if (!createdAt || !updatedAt) {
    return null;
  }

  return (
    <Card title={t`Information`}>
      {createdAt && (
        <DisplayValue label={t`Created`} Icon={CalendarPlus}>
          {formatUtils.date(createdAt, DateFormat.DateTime)}
        </DisplayValue>
      )}
      {updatedAt && (
        <DisplayValue label={t`Updated`} Icon={CalendarClock}>
          {formatUtils.date(updatedAt, DateFormat.DateTime)}
        </DisplayValue>
      )}
      {children}
    </Card>
  );
});
